export const HOME:string = '/';
export const SIGN:string = '/sign';
export const AUTHENTICODE:string = '/authenticode';
export const IMPRINT:string = '/imprint';

